import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { CompaniesFormConfig } from '../components/company-form/company-form.types';

// Loads the static layout config for the company form (section order, labels, payload keys,
// dependencies, service tokens). Mirrors PurchaseOrderFormConfigService, with one addition: the
// response is cached with shareReplay because the form re-derives its descriptors every time the
// `international_company` field changes and must not re-download the asset each time.
@Injectable({ providedIn: 'root' })
export class CompaniesFormConfigService {

  private readonly CONFIG_URL = 'assets/financial-hub/companies-form.config.json';

  private config$: Observable<CompaniesFormConfig> | null = null;

  constructor(private readonly http: HttpClient) {}

  getConfig(): Observable<CompaniesFormConfig> {
    // Swap CONFIG_URL for a real API endpoint when available:
    // private readonly CONFIG_URL = 'https://your-api/financial-hub/config/companies-form';
    if (!this.config$) {
      this.config$ = this.http.get<CompaniesFormConfig>(this.CONFIG_URL)
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.config$;
  }
}
